import type { Promocode } from "../types/booking"

const changeLanguage = (language: string, promocode?: Promocode) => {
  const loc = window.location
  const parts = loc.pathname.split("/")
  const restOfUrl = parts.slice(2).join("/")
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  if (promocode && promocode.code) {
    window.location.href = `${window.location.origin}/${language}/${restOfUrl}${loc.search}&promocode=${promocode.code}`
  } else {
    window.location.href = `${window.location.origin}/${language}/${restOfUrl}${loc.search}`
  }
}

export default changeLanguage
